import { render, staticRenderFns } from "./StagingRuntimeCard.vue?vue&type=template&id=880cf8d6&scoped=true&"
import script from "./StagingRuntimeCard.vue?vue&type=script&lang=js&"
export * from "./StagingRuntimeCard.vue?vue&type=script&lang=js&"
import style0 from "./StagingRuntimeCard.vue?vue&type=style&index=0&id=880cf8d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880cf8d6",
  null
  
)

export default component.exports